export default __webpack_public_path__ + "static/media/coin_l.382a1e10.png";